/**
 * Progressive images:
 * - Render 100x100 thumbnail in src
 * - Store hi-res in data-src / data-srcset / data-sizes
 * - Upgrade when near viewport (or idle fallback)
 */
;(function () {
  const IMG_SELECTOR = 'img[data-progressive-image="true"]'
  const ROOT_MARGIN = '200px'

  function upgradeSources(pictureEl) {
    if (!pictureEl) return
    pictureEl.querySelectorAll('source[data-srcset]').forEach(source => {
      const srcsetData = source.dataset.srcset
      if (srcsetData) {
        source.setAttribute('srcset', srcsetData)
        delete source.dataset.srcset
      }
    })
  }

  function upgradeImg(img) {
    if (!img || img.dataset.progressiveUpgraded === 'true') return

    img.dataset.progressiveUpgraded = 'true'

    // Upgrade picture sources first (if any)
    const picture = img.closest('picture')
    if (picture) upgradeSources(picture)

    const nextSrc = img.dataset.src
    const nextSrcset = img.dataset.srcset
    const nextSizes = img.dataset.sizes

    // Listen once: when hi-res is ready, mark loaded
    img.addEventListener(
      'load',
      () => {
        img.classList.add('progressive-image--loaded')
      },
      { once: true }
    )

    if (nextSizes) img.setAttribute('sizes', nextSizes)
    if (nextSrcset) img.setAttribute('srcset', nextSrcset)
    if (nextSrc) img.setAttribute('src', nextSrc)

    delete img.dataset.src
    delete img.dataset.srcset
    delete img.dataset.sizes
  }

  function initOne(img) {
    if (!img || img.dataset.progressiveBound === 'true') return
    img.dataset.progressiveBound = 'true'

    // If the image is already fully loaded (cache), still mark
    if (img.complete && img.dataset.progressiveUpgraded === 'true') {
      img.classList.add('progressive-image--loaded')
    }
  }

  function initAll(root = document) {
    root.querySelectorAll(IMG_SELECTOR).forEach(initOne)
  }

  function observeAll() {
    const imgs = Array.from(document.querySelectorAll(IMG_SELECTOR))
    if (imgs.length === 0) return

    // Ensure bound
    imgs.forEach(initOne)

    // No IntersectionObserver → upgrade immediately (still progressive in cache)
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(upgradeImg)
      return
    }

    const io = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          io.unobserve(entry.target)
          upgradeImg(entry.target)
        })
      },
      {
        rootMargin: ROOT_MARGIN,
        trackVisibility: true,
        delay: 100
      }
    )

    imgs.forEach(img => io.observe(img))

    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        () => {
          document.querySelectorAll(`${IMG_SELECTOR}:not([data-progressive-upgraded="true"])`).forEach(upgradeImg)
        },
        { timeout: 5000 }
      )
    }
  }

  // Run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll()
      observeAll()
    })
  } else {
    initAll()
    observeAll()
  }

  // Theme editor / dynamic section re-render: allow re-init
  document.addEventListener('shopify:section:load', event => {
    initAll(event.target)
    observeAll()
  })
})()
